// extracted by mini-css-extract-plugin
module.exports = {"root":"unsubscribe_root__1kju5","btn":"unsubscribe_btn__2_WEm","popup":"unsubscribe_popup__3m3hS","head":"unsubscribe_head__c6ung","text":"unsubscribe_text__1H0e5"};